import { LOCALES, type LocaleCode, type MessageTree } from "@/i18n/messages";

type Path<T> = T extends object
  ? {
      [K in keyof T & string]: T[K] extends object ? `${K}.${Path<T[K]>}` : K;
    }[keyof T & string]
  : never;

export type MessageKey = Path<MessageTree>;

export type TranslateParams = Record<string, string | number>;

function getByPath(tree: MessageTree, path: string): string | undefined {
  const parts = path.split(".");
  let cur: unknown = tree;
  for (const p of parts) {
    if (!cur || typeof cur !== "object") return undefined;
    cur = (cur as Record<string, unknown>)[p];
  }
  return typeof cur === "string" ? cur : undefined;
}

function applyParams(template: string, params?: TranslateParams): string {
  if (!params) return template;
  let out = template;
  for (const [k, v] of Object.entries(params)) {
    out = out.split(`{${k}}`).join(String(v));
  }
  return out;
}

export function translate(
  locale: LocaleCode,
  key: MessageKey | string,
  params?: TranslateParams,
): string {
  const primary = getByPath(LOCALES[locale] || LOCALES.en, key);
  if (primary) return applyParams(primary, params);
  const fallback = getByPath(LOCALES.en, key);
  return applyParams(fallback || key, params);
}
